
export default {
  props: ['config', 'title', 'description', 'id', 'blockId', 'role', 'default', 'options'],
  data() {
    return {
      newValue: this.config && this.config[this.id] || this.default || "",
    }
  },
  beforeDestroy() {
    if (this.error) this.setConfig(this.initialValue)
  },
  methods: {
    setConfig(value) {
      const config = { ...this.config }
      config[this.id] = value

      console.warn("setBlockConfig: ", "setConfig")
      this.$store.dispatch('editor/setBlockConfig', {
        id: this.blockId,
        role: this.role,
        config: config,
      })
    },
  },
  computed: {
    initialValue() {
      return this.newValue = this.config && this.config[this.id] || this.default || ""
    },
    error() {
      return this.$v.$error
    },
  },
  watch: {
    newValue() {
      !this.error && this.setConfig(this.$v.newValue.$model)
    },
  },
}
